import { SubSimulationJSON } from '@visualizer/types';
import { getGrid } from 'store/LoadingStore';
import { requireApp } from 'store/assertions';

type FileManagerRequest = {
    dataCategory: 'LAYER' | 'GEOMETRY';
    instruction: 'SAVE' | 'CREATE' | 'DELETE' | 'EDIT' | 'MIXER' | 'EDIT_GEODATA';
    options: any;
    javaArgs?: string[];
};

export async function callFileManager(request: FileManagerRequest): Promise<any> {
    const { user, projectId, gridId, apiClient } = requireApp();
    request.javaArgs = [
        '-pt',
        '', // The backend will fill this parameter with the correct S3 bucket
        '-co',
        user.account_id,
        '-pr',
        projectId,
        '-gr',
        gridId,
        '-gd',
        getGrid().getActiveGeodata().id,
        '-sm',
        getGrid().getSimulationSet().id,
    ];
    const response = await apiClient.put('filemanager', request);
    return response.data;
}

export type ParentMixerLayer = {
    layer: string;
    weight: number;
    invert: boolean;
    isRangeNormalization: boolean;
};

export type ValueMixerLayer = {
    id: number;
    value: number;
    direction: {
        x: number;
        y: number;
        z: number;
    };
};

export async function saveFrameInNewLayer(
    values: ValueMixerLayer[],
    sensorPointsN: number,
    simKind: number,
    layerName: string,
    frameName: string,
    resultLabel: string,
    measureUnit: string
): Promise<SubSimulationJSON> {
    return callFileManager({
        dataCategory: 'LAYER',
        instruction: 'SAVE',
        options: {
            layerName,
            frameName,
            resultLabel,
            measureUnit,
            sensorPointsN,
            simKind,
            values,
        },
    });
}

export async function exportMixInNewLayer(
    sensorPointsN: number,
    parents: ParentMixerLayer[],
    values: ValueMixerLayer[],
    layerName?: string
): Promise<SubSimulationJSON> {
    const name = layerName || `Mixed Layer`;
    return callFileManager({
        dataCategory: 'LAYER',
        instruction: 'MIXER',
        options: {
            layerName: name,
            sensorPointsN,
            parents,
            values,
        },
    });
}
